var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"wrapClassName":"fullpage-model","visible":_vm.visibleValue,"title":null,"footer":null,"closable":false},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('div',{staticClass:"close-btn"},[_c('i',{staticClass:"iconfont icon-close",on:{"click":_vm.handleCancel}})]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }